import * as React from 'react';
import './styles.css';

export default function InputDate(props) {
    const inputRef = React.useRef(null);
    const {
        label,
        className = '',
        variant,
        placeHolder,
        kind,
        ...rest
    } = props;

    const openPicker = () => {
        if (!inputRef.current || rest.disabled) {
            return;
        }

        inputRef.current.focus();
        if (typeof inputRef.current.showPicker === 'function') {
            try {
                inputRef.current.showPicker();
            } catch (error) {
                // Some browsers block showPicker outside direct user gesture.
            }
        }
    };

    const inputEl = (
        <input
            ref={inputRef}
            type="date"
            className={`input-date-field ${variant || ''}`.trim()}
            id={rest.id}
            name={rest.name}
            required={rest.required}
            placeholder={placeHolder}
            value={rest.value || ''}
            onChange={rest.onChange}
            min={rest.min}
            max={rest.max}
            disabled={rest.disabled || false}
            onClick={openPicker}
        />
    );

    if (!label) {
        return (
            <div className={`input-date-wrap ${className}`.trim()}>
                {inputEl}
            </div>
        );
    }

    return (
        <div className={`input-control ${className}`.trim()} onClick={openPicker}>
            <label htmlFor={rest.id}>{label}</label>
            {inputEl}
        </div>
    );
}
